import { EPageTypes, EPlatformTypes, handleDynamicCalltracking } from '@cian/frontend-dynamic-calltracking-component';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';

import { TPlaceType } from '../../types/calltracking';

interface IDynamicCalltrackingParameters {
  siteBlockId?: number | null;
  placeType: TPlaceType;
  announcementId?: number | null;
}

interface IDynamicCalltrackingResponse {
  phone: string | null;
}

export async function dynamicCalltracking({
  siteBlockId,
  placeType,
  announcementId,
}: IDynamicCalltrackingParameters): Promise<IDynamicCalltrackingResponse> {
  if (siteBlockId == null) {
    return {
      phone: null,
    };
  }

  const response = await handleDynamicCalltracking({
    blockId: siteBlockId,
    httpApi: getHttpApi(),
    logger: getLogger(),
    platformType: EPlatformTypes.WebDesktop,
    pageType: EPageTypes.OfferComparison,
    placeType,
    announcementId,
  });

  return {
    phone: response.phone,
  };
}
